type ConvertValueFunction = (value: number) => number;
type ConvertSymbolFunction = (value: number) => string;

interface UnitSet {
  name: string;
  convertSymbolFunction: ConvertSymbolFunction;
  convertValueFunction: ConvertValueFunction;
}

function converterBuilder() {
  const unitSets: {[key: string]: UnitSet} = {};

  const builder = {
    addUnit,
    build,
  };

  const converter = {
    to,
  };

  function addUnit(name: string, convertSymbolFunction: ConvertSymbolFunction, conversionFunction: ConvertValueFunction) {
    unitSets[name] = {name, convertSymbolFunction, convertValueFunction: conversionFunction};
    return builder;
  }

  function build() {
    return converter;
  }

  function to(name: string, value: number) {
    const unitSet = unitSets[name];
    const {convertValueFunction, convertSymbolFunction} = unitSet;
    return {
      name,
      value: convertValueFunction(value),
      symbol: convertSymbolFunction(value),
    };
  }

  return builder;
}

export default converterBuilder;
